/* @flow */
import React, { PropTypes } from 'react';

import Translate from 'react-translate-component';

import FaqAutosuggest from './faq-autosuggest';
import FaqGroup from './faq-group';

class FaqPage extends React.Component {

  static propTypes = {
    faqs: PropTypes.array
  };

  constructor (props) {
    super(props);

    this.state = {
      faqs: this.props.faqs
    };

    this.faqItemRefs = {};

    this.addFaqItemRef = this.addFaqItemRef.bind(this);
    this.toggleFaqGroup = this.toggleFaqGroup.bind(this);
    this.toggleFaqItem = this.toggleFaqItem.bind(this);
    this.showFaqItem = this.showFaqItem.bind(this);
  }

  addFaqItemRef (faqItem, ref) {
    const obj = {};

    obj[faqItem.id] = ref;

    this.faqItemRefs[faqItem.groupId] = {
      ...this.faqItemRefs[faqItem.groupId],
      ...obj
    };
  }

  toggleFaqGroup (id) {
    const faqs = this.state.faqs.map((faq) => {
      if (faq.id === id) {
        faq.isActive = !faq.isActive;
      }

      return faq;
    });

    this.setState({
      faqs
    });
  }

  toggleFaqItem (id) {
    const faqs = this.state.faqs.map((faq) => {
      faq.questionGroup = faq.questionGroup.map((question) => {
        if (question.id === id) {
          question.isActive = !question.isActive;
        }

        return question;
      });

      return faq;
    });

    this.setState({
      faqs
    });
  }

  showFaqItem (suggestion) {
    const faqs = this.state.faqs.map((faq) => {
      if (faq.id === suggestion.groupId) {
        faq.isActive = true;
      }

      faq.questionGroup = faq.questionGroup.map((question) => {
        if (question.id === suggestion.id) {
          question.isActive = true;
        }

        return question;
      });

      return faq;
    });

    this.setState({
      faqs
    }, () => this.scrollToFaqItem(suggestion));
  }

  scrollToFaqItem (suggestion) {
    const item = this.faqItemRefs[suggestion.groupId][suggestion.id];
    const header = document.querySelector('.page-header.sticky');

    window.scrollTo(0, item.getBoundingClientRect().top - header.offsetHeight);
  }

  render () {
    return (
      <div className="faq-page">
        <div className="container">
          <div className="row">
            <div className="col-sm-10">
              <h2><Translate content="FAQ"/></h2>
              <FaqAutosuggest
                faqs={this.state.faqs}
                showFaqItem={this.showFaqItem}
              />
              <div className="accordion">
                {this.state.faqs.map((group) => {
                  return (<FaqGroup
                    key={group.id}
                    {...group}
                    toggle={this.toggleFaqGroup}
                    toggleFaqItem={this.toggleFaqItem}
                    addFaqItemRef={this.addFaqItemRef}
                  />);
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FaqPage;



/** WEBPACK FOOTER **
 ** ./src/views/faq/faq-page.js
 **/